<template>
  <div>
    <v-row style="margin-top:-20px"><v-subheader><b>{{ $t('TEMPLATE LIST') }}</b></v-subheader></v-row>
    <v-data-table v-model="template_list" :headers="templateHeaders" :items="initaldata" item-key="uniqueid"
      :hide-default-footer="true" height="417" class="tbl-type01 type3" :items-per-page="2000" @click:row="getpreview"
      single-select>
      <template slot="no-data">
        <p>{{ $t('No data available') }}</p>
      </template>
      <template v-slot:[`item.icon`]="{ item }">
        <v-icon v-if="permissionSetValue == 'company' && item.templateName != ''" style="color:red"
          @click.stop="deleteSelectedTemplate(item)" medium>mdi-close-circle </v-icon>
        <v-icon v-else-if="permissionSetValue == 'country' && item.areaKey !== 'company' && item.templateName != ''"
          style="color:red" @click.stop="deleteSelectedTemplate(item)" medium>mdi-close-circle </v-icon>
        <v-icon
          v-else-if="permissionSetValue == 'region' && item.areaKey !== 'country' && item.areaKey !== 'company' && item.templateName != ''"
          style="color:red" @click.stop="deleteSelectedTemplate(item)" medium>mdi-close-circle </v-icon>
        <v-icon
          v-else-if="permissionSetValue == 'city' && item.areaKey !== 'country' && item.areaKey !== 'company' && item.areaKey !== 'region' && item.templateName != ''"
          style="color:red" @click.stop="deleteSelectedTemplate(item)" medium>mdi-close-circle </v-icon>
        <v-icon
          v-else-if="permissionSetValue == 'store' && item.templateName != '' && item.areaKey !== 'country' && item.areaKey !== 'company' && item.areaKey !== 'region' && item.area !== 'City'"
          style="color:red" @click.stop="deleteSelectedTemplate(item)" medium>mdi-close-circle </v-icon>
        <span v-else>
          <v-icon></v-icon>
        </span>
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <img v-if="
          (
            permissionSetValue == 'company' && item.templateName != ''
          ) ||
          (
            permissionSetValue == 'country' && item.areaKey !== 'company' && item.templateName != ''
          ) ||
          (
            permissionSetValue == 'region' && item.areaKey !== 'country' && item.areaKey !== 'company' && item.templateName != ''
          ) ||
          (
            permissionSetValue == 'city' && item.areaKey !== 'country' && item.areaKey !== 'company' && item.areaKey !== 'region' && item.templateName != ''
          ) ||
          (
            permissionSetValue == 'store' && item.templateName != '' && item.areaKey !== 'country' && item.areaKey !== 'company' && item.areaKey !== 'region' && item.area !== 'City'
          )
        " :src="isSelectedRow(item) ? require('@/assets/img/ico_down.svg') : require('@/assets/img/ico_down_popup.svg')"
          style="margin-right: 15px; height: 18px; cursor: pointer;" @click.stop="downloadSelectedTemplate(item)" />
      </template>
      <template v-slot:[`item.templateName`]="{ item }">
        <span v-if="item.templateName">{{ item.templateName }}</span>
        <img v-else width="20" height="20"
          :src="isSelectedRow(item) ? require('@/assets/img/ico_upload.svg') : require('@/assets/img/ic_upload.svg')"
          style="cursor: pointer;margin: auto !important;display: flex;"
          @click.stop="handleOpenSelectTemplateTypeFile(item)" />
      </template>
      <template v-slot:[`item.areaKey`]="{ item }">
        <span>{{ $t(item.areaKey) }}</span>
      </template>
    </v-data-table>
    <v-row style="margin-top:20px;">
      <v-btn :disabled="saveButtonDisabled || btndisabled" @click="saveSelectedTemplateList()" text class="btn ml-2">{{
        $t('Save') }}</v-btn>
      <v-btn :disabled="!saveButtonDisabled || btndisabled" @click="ReapplySelectedTemplateList()" text
        class="btn ml-2">{{
          $t('Reapply') }}</v-btn>
    </v-row>
    <div>
      <v-dialog v-model="UploadOptions" persistent width="500">
        <v-card class="popup add_store_popup" align="center" justify="center">
          <v-card-title>
            <h3 class="page-title-bar">
              <i class="ico ico-template"></i>{{ $t('Template Upload Option') }}
            </h3>
          </v-card-title>
          <v-row>
            <v-col>
              <v-container style="display: flex;justify-content: center;margin: -50px;">
                <v-radio-group v-model="selectedOption" row>
                  <v-radio :label="`${$t('Upload Now')}`" value="false"></v-radio>
                  <v-radio :label="`${$t('Upload Later')}`" value="true"></v-radio>
                </v-radio-group>
              </v-container>
            </v-col>
          </v-row>
          <v-card-actions class="d-flex justify-center">
            <v-btn @click="handleClickConfirm()" text icon class="btn">{{ $t('Save') }}</v-btn>
            <v-btn @click="UploadOptions = false" text icon class="btn">{{ $t('Cancel') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <v-dialog v-model="openSelectTemplateTypeFileDialog" persistent width="680">
      <v-card class="popup add_store_popup" align="center" justify="center">
        <v-card-title class="d-flex justify-space-between">
          <h3 class="page-title-bar">
             <img
          :src="require('@/assets/img/ic_upload.svg')"
          class="Upload_Ico"
          />
            {{ $t('Template Upload') }}
          </h3>
          <div class="mb-10" style="color: #001e38;font-size: 14px;">
            {{ selectedTemplateTypeRow['areaKey'] }} : {{ selectedTemplateTypeRow['areaValue'] }}
          </div>
        </v-card-title>
        <v-card-text>
          <div class="d-flex align-center justify-space-between mb-2">
            <div class="mr-5 ">
              <b>{{ $t('Template Type') }}</b>
            </div>
            <div class="fake-input-box">
              {{ selectedTempalteType.typeName }} <div class="tempsize"> {{
                selectedTempalteType.templateSize }}
              </div>
            </div>
          </div>
          <div class="d-flex align-center justify-space-between mb-2">
            <div class="mr-5 ">
              <b>{{ $t('XSL File') }}</b><span style="color: red;margin-left: 5px;">*</span>
            </div>
          <div class="fake-input-box" style="background-color: white;border: none;">
              <v-file-input accept="text/xml" @change="(file) => encodeFile(file, 'xsl')" dense :clearable="false"
            :placeholder="`${$t('Select XSL File')} *`" class="form-file fileinput" v-model="selectedXslFile">
          </v-file-input>
          </div>
          </div>
          <div class="d-flex align-center justify-space-between mb-2">
            <div class="mr-5 ">
              <b>{{ $t('JSON File') }}</b><span style="margin-left: 5px;"><sup>({{ $t('Optional') }})</sup></span>
            </div>
            <div class="fake-input-box" style="background-color: white;border: none;">
               <v-file-input accept="application/json" @change="(file) => encodeFile(file, 'json')" dense :clearable="false"
            :placeholder="`${$t('Select JSON File')}`" class="form-file fileinput" v-model="selectedJsonFile">
          </v-file-input>
              </div>
            </div>
        </v-card-text>
        <v-card-actions class="d-flex justify-center">
          <v-btn @click="handleConfirmSelectTemplateTypeFile" text icon class="btn" :disabled="!selectedXslFile">
            {{ $t('Select') }}
          </v-btn>
          <v-btn @click="cancelSelectTemplateTypeFile" text icon class="btn">{{ $t('Cancel') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="TemplateDownloadModel" persistent width="500">
      <v-card class="popup add_store_popup" align="center" justify="center">
        <v-card-title>
          <h3 class="page-title-bar">
            <img
                src="@/assets/img/ico_down_popup.svg"
                style="margin-right: 15px; height: 30px;"
              />
            {{ $t('Download') }}
            <p
              style="font-size: 12px;position: absolute;right: 40px;top: 66px;max-width: 160px;white-space: normal;word-break: break-all;text-align: left;">
              <b>{{ $t('TypeName') }} :</b> {{ selectedTempalteType.typeName }} <br>
              <b>{{ $t('AreaLevel') }} :</b> {{ downloadedItem && downloadedItem['areaKey'] }}<br>
              <b>{{ $t('AreaValue') }} :</b>  {{downloadedItem && downloadedItem['areaValue'] }}
            </p>
          </h3>

        </v-card-title>
        <v-card-text class="text-center" style="margin-top: 10px;">
          <p style="text-align: justify;">{{ $t('Please select the format to download the template file') }}
          </p>
        </v-card-text>
        <br>
        <v-row>
          <v-col>
            <v-container style="justify-content: center;margin: -50px;">
              <p style="text-align: justify; color: rgba(0, 0, 0, 0.6);font-size: 13px;">
                {{ $t('Select type') }}
                <span style="color: red;">*</span>
              </p>
              <v-radio-group v-model="selectedOptionDown" row>
                <v-radio :label="`${$t('XSL')}`" value="1"></v-radio>
                <v-radio  :disabled="!canUseJson" :label="`${$t('Json')}`" value="2"></v-radio>
                <v-radio  :disabled="!canUseJson" :label="`${$t('Both')}`" value="3"></v-radio>
              </v-radio-group>
            </v-container>
          </v-col>
        </v-row>
        <v-card-actions class="d-flex justify-center">
          <v-btn @click="todownloadTemplateFile()" text icon class="btn">{{ $t('Download') }}</v-btn>
          <v-btn @click="TemplateDownloadModel = false" text icon class="btn">{{ $t('Cancel') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import EventBus from '@/plugins/eventBus.js'
import l from 'lodash'
import { v4 as uuidv4 } from 'uuid'
import debounce from 'lodash/debounce'
import codes from '@/plugins/codes'
const requests = {
  putTemplateArea: {
    method: 'put',
    url: '/api/common/templates/area'
  },
  ReapplyTemplateArea: {
    method: 'put',
    url: '/api/common/templates/area/reapply'
  },
  getTemplateArea: {
    method: 'get',
    url: '/api/common/templates/area'
  },
  getImagepreviewData: {
    method: 'get',
    url: '/api/common/templates/preview'
  }
}
export default {
  name: 'SelectedTemplateType',
  props: {
    getselectedValue: [Array, Object, String],
    selectedStoreCode: [Array, Object, String],
    selectedArticleId: [Array, Object, String],
    selectedTemplateType: [Array, Object, String, Number],
    checkdeleteFlag: Boolean
  },
  data () {
    return {
      initaldata: [],
      template_list: [],
      selectedTypename: null,
      selectedModelType: null,
      permissionSetValue: '',
      getselectedTemplateRow: '',
      template: [],
      templateFile: null,
      fileDeleteFlag: false,
      deleteTemplateparam: [],
      saveButtonDisabled: true,
      template_file_name: null,
      templateAreaClick: false,
      btndisabled: false,
      UploadOptions: false,
      selectedOption: 'false',
      TemplateDownloadModel: false,
      selectedOptionDown: '1',
      downloadedItem: null,
      selectedTemplateTypeRow: {},
      openSelectTemplateTypeFileDialog: false,
      selectedXslFile: null,
      selectedJsonFile: null,
      xslFileData: null,
      jsonFileData: null
    }
  },
  computed: {
    templateHeaders () {
      return [
        { text: this.$t('Area'), sortable: false, align: 'left', value: 'areaKey', width: '5%' },
        { text: this.$t('Title'), sortable: false, align: 'left', value: 'areaValue', width: '5%' },
        { text: this.$t('File'), sortable: false, align: 'left', value: 'templateName', width: '10%' },
        { text: '', sortable: false, align: 'center', value: 'icon', width: '10%' },
        { text: this.$t('Download'), sortable: false, align: 'center', value: 'action', width: '10%' }

      ]
    },
    canUseJson () {
      return this.downloadedItem && this.downloadedItem.jsonFileChk === true
    },
    selectedTempalteType () {
      return this.getselectedValue ? this.getselectedValue : ''
    },
    selectedareaTopSearch () {
      var areaValue = ''
      var company = this.$store.state.dataStore.selectedStore.company
      var country = this.$store.state.dataStore.selectedStore.country
      var region = this.$store.state.dataStore.selectedStore.region
      var city = this.$store.state.dataStore.selectedStore.city
      var store = this.$store.state.dataStore.selectedStore.code
      if (!l.isEmpty(store)) {
        areaValue = store
      } else if (!l.isEmpty(city)) {
        areaValue = city
      } else if (!l.isEmpty(region)) {
        areaValue = region
      } else if (!l.isEmpty(country)) {
        areaValue = country
      } else if (!l.isEmpty(company)) {
        areaValue = company
      }
      return areaValue
    },

    getdeleteflag () {
      return this.checkdeleteFlag
    }

  },
  watch: {
    selectedTempalteType () {
      this.getTemplateList()
    },
    selectedareaTopSearch () {
      this.getTemplateList()
    },
    getdeleteflag () {
      if (this.checkdeleteFlag) { this.initaldata = [] }
      this.selectedTempalteType.typeName = null
      this.selectedTempalteType.templateSize = null
      this.selectedTempalteType.templateColor = null
    }

  },
  mounted () {
    this.$store.dispatch('auth/getDisabledBtn', '5100').then(flag => {
      this.btndisabled = flag
    })
  },
  methods: {
    // clear template file
    handleConfirmSelectTemplateTypeFile () {
      if (!this.selectedXslFile) {
        EventBus.$emit('messageAlert', this.$t('Please select an XSL file.'))
        return
      }

      // Prepare template data
      const templateData = {
        typeName: this.selectedTempalteType.typeName,
        templateSize: this.selectedTempalteType.templateSize,
        templateColor: this.selectedTempalteType.templateColor,
        areaKey: this.selectedTemplateTypeRow.areaKey,
        areaValue: this.selectedTemplateTypeRow.areaValue,
        templateData: this.xslFileData,
        templateJsonData: this.jsonFileData || null,
        fileName: this.selectedXslFile.name
      }

      if (this.fileDeleteFlag) {
        const removeIndex = this.deleteTemplateparam
          .map(item => item.areaValue)
          .indexOf(this.selectedTemplateTypeRow.areaValue)
        if (removeIndex !== -1) {
          this.deleteTemplateparam.splice(removeIndex, 1)
        }
        this.deleteTemplateparam.push(templateData)
      } else {
        const removeIndex = this.template
          .map(item => item.areaValue)
          .indexOf(this.selectedTemplateTypeRow.areaValue)
        if (removeIndex !== -1) {
          this.template.splice(removeIndex, 1)
        }
        this.template.push(templateData)
      }

      if (this.template.length > 0) {
        this.saveButtonDisabled = false
      } else {
        if (this.fileDeleteFlag === true) {
          this.saveButtonDisabled = false
        } else {
          this.saveButtonDisabled = true
        }
      }

      // Update the table display
      const objIndex = this.initaldata.findIndex(
        obj => obj.areaValue === this.selectedTemplateTypeRow.areaValue
      )
      if (objIndex !== -1) {
        this.initaldata[objIndex].templateName = this.selectedXslFile.name
      }

      // Close dialog and reset
      this.openSelectTemplateTypeFileDialog = false
      this.selectedTemplateTypeRow = {}
      this.selectedXslFile = null
      this.selectedJsonFile = null
      this.xslFileData = null
      this.jsonFileData = null
    },
    handleOpenSelectTemplateTypeFile (item) {
      this.openSelectTemplateTypeFileDialog = true
      this.selectedTemplateTypeRow = { ...item }
      // Reset file selections when opening dialog
      this.selectedXslFile = null
      this.selectedJsonFile = null
      this.xslFileData = null
      this.jsonFileData = null
    },

    cancelSelectTemplateTypeFile () {
      this.openSelectTemplateTypeFileDialog = false
      this.selectedTemplateTypeRow = {}
      // Clear file selections
      this.selectedXslFile = null
      this.selectedJsonFile = null
      this.xslFileData = null
      this.jsonFileData = null
    },
    clearFile (item) {
      var removeIndex = this.template.map(function (item) { return item.areaValue }).indexOf(item.areaValue)
      this.template.splice(removeIndex, 1)

      if (this.template.length > 0) {
        this.saveButtonDisabled = false
      } else {
        if (this.fileDeleteFlag === true) {
          this.saveButtonDisabled = false
        } else {
          this.saveButtonDisabled = true
        }
      }
    },
    // get template list
    getTemplateList: debounce(function () {
      this.templateAreaClick = false
      if (this.selectedTempalteType === undefined || this.selectedTempalteType === '') {
        this.initaldata = []
        this.$emit('getpreviewImage', { imageContent: '', areaData: '', templateName: this.selectedTempalteType })
        return
      }
      var areaKey = ''
      var areaValue = ''
      var company = this.$store.state.dataStore.selectedStore.company
      var country = this.$store.state.dataStore.selectedStore.country
      var region = this.$store.state.dataStore.selectedStore.region
      var city = this.$store.state.dataStore.selectedStore.city
      var store = this.$store.state.dataStore.selectedStore.code
      if (!l.isEmpty(store)) {
        areaKey = 'store'
        areaValue = store
      } else if (!l.isEmpty(city)) {
        areaKey = 'city'
        areaValue = city
      } else if (!l.isEmpty(region)) {
        areaKey = 'region'
        areaValue = region
      } else if (!l.isEmpty(country)) {
        areaKey = 'country'
        areaValue = country
      } else if (!l.isEmpty(company)) {
        areaKey = 'company'
        areaValue = company
      }
      this.$emit('getpreviewImage', { imageContent: '', areaData: '', templateName: this.selectedTempalteType.typeName })
      this.$emit('selectedStoreValue', { selectedAreaKey: areaKey, selectedAreaValue: areaValue, randomvalue: uuidv4() })
      this.permissionSetValue = this.$store.state.dataStore.permissionKey
      // this.permissionSetValue = 'region'
      this.initaldata = []
      this.template_list = []
      this.deleteTemplateparam = []
      this.template = []
      this.saveButtonDisabled = true
      // const params = {
      //   typeName: this.selectedTempalteType.typeName,
      //   templateSize: this.selectedTempalteType.templateSize,
      //   areaKey: areaKey,
      //   areaValue: areaValue
      // }
      var params = {}
      if (store) {
        params = {
          typeName: this.selectedTempalteType.typeName,
          templateSize: this.selectedTempalteType.templateSize,
          templateColor: this.selectedTempalteType.templateColor,
          areaKey: areaKey,
          areaValue: areaValue
        }
      }
      if (!store) {
        params = {
          typeName: this.selectedTempalteType.typeName,
          templateSize: this.selectedTempalteType.templateSize,
          templateColor: this.selectedTempalteType.templateColor,
          areaKey: this.$store.state.dataStore.permissionKey,
          areaValue: this.$store.state.dataStore.permissionValue
        }
      }

      const config = { params: params }
      this.$utils
        .callAxios(
          requests.getTemplateArea.method,
          requests.getTemplateArea.url,
          config
        )
        .then(res => {
          this.handleGetTempaltesResponse(res)
        })
        .catch(error => {
          this.handleGetTempaltesError(error)
        })
    }, 300),
    handleGetTempaltesResponse (res) {
      if (res.status === 200 && res.data.length > 0) {
        var selectedList = res.data
        this.initaldata = []
        for (var i = 0; i < selectedList.length; i++) {
          var enable = ''
          if (this.permissionSetValue === 'company') {
            enable = false
          }
          if (this.permissionSetValue === 'country') {
            if (selectedList[i].id.areaKey === 'company') {
              enable = true
            } else {
              enable = false
            }
          }
          if (this.permissionSetValue === 'region') {
            if (selectedList[i].id.areaKey === 'company' || selectedList[i].id.areaKey === 'country') {
              enable = true
            } else {
              enable = false
            }
          }
          if (this.permissionSetValue === 'city') {
            if (selectedList[i].id.areaKey === 'company' || selectedList[i].id.areaKey === 'country' || selectedList[i].id.areaKey === 'region') {
              enable = true
            } else {
              enable = false
            }
          }
          if (this.permissionSetValue === 'store') {
            if (selectedList[i].id.areaKey === 'company' || selectedList[i].id.areaKey === 'country' || selectedList[i].id.areaKey === 'region' || selectedList[i].id.areaKey === 'city') {
              enable = true
            } else {
              enable = false
            }
          }
          this.initaldata.push({
            areaKey: selectedList[i].id.areaKey,
            areaValue: selectedList[i].id.areaValue,
            templateName: selectedList[i].templateName,
            icon: false,
            enable: enable,
            // to generate unique id
            uniqueid: `template_key_${i}`,
            jsonFileChk: selectedList[i].jsonFileChk
          })
        }
        this.$emit('getareaKeyValue', { getareaDetails: this.initaldata[0] })

        this.template_list.push(this.initaldata[0])
        setTimeout(() =>
          this.getpreview(this.initaldata[0])
        , 1000)
        // if (this.selectedTemplateType === 1) {
        //   this.getpreview(this.initaldata[0])
        // }
      }
    },
    handleGetTempaltesError (error) {
      console.log(error)
      this.initaldata = []
      this.selectedTempalteType.typeName = null
      this.selectedTempalteType.templateSize = null
      this.selectedTempalteType.templateColor = null
    },
    getpreview (item, row) {
      this.getselectedTemplateRow = ''
      this.template_file_name = item.templateName
      if (row !== undefined) {
        row.select(true)
        this.templateAreaClick = true
      }

      this.$emit('getareaKeyValue', { getareaDetails: item })
      this.$emit('areaClickEvent', { templateAreaClick: this.templateAreaClick })
      this.getselectedTemplateRow = item
      // if (item.enable && item.templateName === '') {
      //   this.$emit('getpreviewImage', { imageContent: '', areaData: '' })
      //   return
      // }
      // if (item.templateName === '') {
      //   this.$emit('getpreviewImage', { imageContent: '', areaData: '' })
      //   return
      // }
      // if (this.selectedStoreCode === '' || this.selectedStoreCode === undefined) {
      //   return
      // }
      const params1 = { areaKey: item.areaKey, areaValue: item.areaValue, typeName: this.selectedTempalteType.typeName, storeCode: this.selectedStoreCode, articleId: this.selectedArticleId, fileName: item.templateName }

      this.$emit('getpreviewImage', { imageContent: '', areaData: params1, templateName: this.selectedTempalteType.typeName })

      setTimeout(() => {
        const params = { areaKey: item.areaKey, areaValue: item.areaValue, typeName: this.selectedTempalteType.typeName, storeCode: this.selectedStoreCode, articleId: this.selectedArticleId, fileName: item.templateName }
        const config = { params: params }

        this.changestoreFlag = false
        if (this.selectedTempalteType.typeName !== '') {
          this.$utils
            .callAxios(
              requests.getImagepreviewData.method,
              requests.getImagepreviewData.url,
              config
            )
            .then(res => {
              this.templateAreaClick = false
              const result = res.data
              this.$emit('getpreviewImage', { imageContent: result, areaData: params, templateName: this.selectedTempalteType.typeName })
              this.$emit('areaClickEvent', { templateAreaClick: this.templateAreaClick })
            })
            .catch(error => {
              this.$emit('getpreviewImage', { imageContent: '', areaData: '', templateName: this.selectedTempalteType.typeName })
              console.log(error)
            })
        } else {
          this.$emit('getpreviewImage', { imageContent: '', areaData: '', templateName: this.selectedTempalteType.typeName })
        }
      }, 1000)
    },
    deleteSelectedTemplate (item) {
      this.saveButtonDisabled = false
      const objIndex = this.initaldata.findIndex(obj => obj.areaValue === item.areaValue)
      this.initaldata[objIndex].templateName = ''

      this.fileDeleteFlag = true

      this.deleteTemplateparam.push({
        typeName: this.selectedTempalteType.typeName,
        templateSize: this.selectedTempalteType.templateSize,
        templateColor: this.selectedTempalteType.templateColor,
        areaKey: item.areaKey,
        areaValue: item.areaValue,
        fileName: '',
        templateData: ''

      })
    },
    async encodeFile (event, fileType) {
      if (event === null || event === undefined) {
        return
      }

      // Determine if this is XSL or JSON file
      const isJsonFile = event.type === 'application/json'
      const isXslFile = event.type === 'text/xml' || event.type === 'application/xml' || event.type === 'application/xslt+xml'

      // Validate file type
      if (fileType === 'xsl' && !isXslFile) {
        EventBus.$emit(
          'messageAlert',
          this.$t("Template file's filename extension must be XSL.")
        )
        return
      }

      if (fileType === 'json' && !isJsonFile) {
        EventBus.$emit(
          'messageAlert',
          this.$t('File must be a valid JSON file.')
        )
        return
      }

      // Store file reference
      if (fileType === 'xsl') {
        this.selectedXslFile = event
      } else if (fileType === 'json') {
        this.selectedJsonFile = event
      }

      // Process JSON file
      if (isJsonFile) {
        const fileText = await event.text()
        try {
          const jsonData = JSON.parse(fileText)
          this.jsonFileData = jsonData
        } catch (e) {
          EventBus.$emit('messageAlert', this.$t('Invalid JSON file.'))
          this.selectedJsonFile = null
          this.jsonFileData = null
          return
        }
      }

      // Process XSL file
      if (isXslFile) {
        const reader = new FileReader()
        reader.addEventListener(
          'load',
          () => {
            let result = reader.result
            if (result.startsWith('data:')) {
              const base64Idx = 'base64,'
              const strToRemove = result.substring(
                0,
                result.indexOf(base64Idx, 0) + base64Idx.length
              )
              result = result.substring(strToRemove.length, result.length)
            }
            this.xslFileData = result
          },
          false
        )
        await reader.readAsDataURL(event)
      }
    },
    // save method
    saveSelectedTemplateList () {
      this.selectedOption = 'false'
      this.UploadOptions = true
    },
    handleClickConfirm () {
      var template = this.template.concat(this.deleteTemplateparam)
      const data = this.selectedOption.toLowerCase()
      var finalFlag = null
      if (data === 'true') {
        finalFlag = true
      } else {
        finalFlag = false
      }
      const params = { updateLater: finalFlag }
      const config = { params: params }
      this.$utils
        .callAxiosWithBody(
          requests.putTemplateArea.method,
          requests.putTemplateArea.url,
          template,
          config
        )
        .then(res => {
          const result = res.data
          EventBus.$emit('messageAlert', this.$t(result.responseMessage))
          this.template = []
          this.deleteTemplateparam = []
          this.getselectedTemplateRow = ''
          this.fileDeleteFlag = false
          this.saveButtonDisabled = true
          if (result.responseCode === '200') {
            this.getTemplateList()
            this.UploadOptions = false
          }
          // this.template = []
        })
        .catch(error => {
          var errormsg = error.response
          this.template = []
          this.deleteTemplateparam = []
          this.fileDeleteFlag = false
          this.getTemplateList()
          this.UploadOptions = false
          this.saveButtonDisabled = true
          if (errormsg.status === 405) {
            EventBus.$emit('messageAlert', this.$t(errormsg.data.responseMessage))
          } else {
            EventBus.$emit('messageAlert', this.$t('Fail to update template area'))
          }
        })
    },

    // ReApply
    ReapplySelectedTemplateList () {
      // console.log(this.template_file_name)
      if (this.template_file_name === null || this.template_file_name === undefined || this.template_file_name === '') {
        EventBus.$emit('messageAlert', this.$t('There is no file to Reapply'))
        return
      }
      const params = {
        typeName: this.selectedTempalteType.typeName,
        templateSize: this.selectedTempalteType.templateSize,
        templateColor: this.selectedTempalteType.templateColor,
        areaKey: this.getselectedTemplateRow.areaKey,
        areaValue: this.getselectedTemplateRow.areaValue,
        fileName: this.template_file_name,
        updateLater: false

      }
      // console.log(params)
      this.$utils
        .callAxiosWithBody(
          requests.ReapplyTemplateArea.method,
          requests.ReapplyTemplateArea.url,
          params
        )
        .then(res => {
          const result = res.data
          EventBus.$emit('messageAlert', this.$t(result.responseMessage))
          this.getTemplateList()
          // this.reapplybuttondisabled = true
          // this.template = []
        })
        .catch(error => {
          var errormsg = error.response
          this.getTemplateList()
          if (errormsg.status === 405) {
            EventBus.$emit('messageAlert', this.$t(errormsg.data.responseMessage))
          } else {
            EventBus.$emit('messageAlert', this.$t('Fail to update template area'))
          }
        })
    },

    // Handle download template
    downloadSelectedTemplate (item) {
      this.downloadedItem = item
      this.TemplateDownloadModel = true
      this.selectedOptionDown = item.jsonFileChk ? '2' : '1'
    },
    isSelectedRow (item) {
      return this.template_list && this.template_list[0] && this.template_list[0].uniqueid === item.uniqueid
    },
    cleanFileName (name) {
      return name
        .replace(/\.xsl/gi, '')
        .replace(/\.json/gi, '')
        .trim()
    },

    // Download template file
    todownloadTemplateFile () {
      const option = this.selectedOptionDown
      const formats =
    option === '3'
      ? ['XSL', 'JSON']
      : option === '1'
        ? ['XSL']
        : ['JSON']

      formats.forEach(type => {
        const config = {
          params: {
            templateName: this.downloadedItem.templateName,
            dataType: type
          }
        }

        this.$utils
          .callAxios(
            codes.requests.todownloadTemplate.method,
            codes.requests.todownloadTemplate.url,
            config
          )
          .then(res => {
            if (type === 'JSON') {
              let rawContent = res.data.contentData
              if (typeof rawContent === 'string') {
                try {
                  rawContent = JSON.parse(rawContent)
                } catch (e) {
                  console.error('Invalid JSON string', e)
                }
              }
              const jsonString = JSON.stringify(rawContent, null, 2)
              const blob = new Blob([jsonString], { type: 'application/json' })
              const baseName = this.cleanFileName(this.downloadedItem.templateName)
              const filename = `${baseName}.json`
              const link = document.createElement('a')
              link.href = URL.createObjectURL(blob)
              link.download = filename
              link.click()
              URL.revokeObjectURL(link.href)
              this.TemplateDownloadModel = false
              return
            }
            const base64 = res.data.contentData
            const binary = atob(base64)
            const bytes = new Uint8Array(binary.length)
            for (let i = 0; i < binary.length; i++) {
              bytes[i] = binary.charCodeAt(i)
            }
            const blob = new Blob([bytes], { type: 'application/octet-stream' })
            const baseName = this.cleanFileName(this.downloadedItem.templateName)
            const filename = `${baseName}.xsl`
            const link = document.createElement('a')
            link.href = URL.createObjectURL(blob)
            link.download = filename
            link.click()
            URL.revokeObjectURL(link.href)
            this.TemplateDownloadModel = false
          })
          .catch(err => console.error(err))
      })
    }
  }
}
</script>
<style scoped>
.fake-input-box {
  background-color: #ecebeb;
  border-radius: 5px;
  margin-top: 20px;
  border: 1px solid #333;
  padding: 7px 11px;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  width: 60%;
}

.tempsize {
  display: inline-block;
  padding: 2px 4px;
  background-color: #666;
  color: #fff;
  border-radius: 3px;
  margin-left: 10px;
}

::v-deep tr.v-data-table__selected {
  background: #09263f !important
}

::v-deep tr.v-data-table__selected td {
  color: #ffffff !important
}

::v-deep tr.v-data-table__selected td .v-input__control {
  color: #ffffff !important
}

::v-deep tr.v-data-table__selected td .v-file-input .v-file-input__text--placeholder {
  color: #ffffff !important
}

::v-deep tr.v-data-table__selected td .v-file-input .v-file-input__text {
  color: #ffffff !important
}

::v-deep .type3 {
  border: 1px solid #001e38;
}

::v-deep .fileinput {
  font-size: 12px !important;
}

::v-deep .form-file.v-input--is-disabled .v-input__control {
  background: transparent !important;
}
.Upload_Ico {
  display: inline-block;
  width: 33px;
  height: 32px;
  margin-right: 15px;
  vertical-align: top;
  background-position: top left;
  background-repeat: no-repeat;
}
</style>
